import React from 'react';
import { Link } from 'react-router-dom';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '@/supabaseClient';

function isInAppBrowser() {
  const userAgent = navigator.userAgent || window.opera;
  
  // Social media apps
  if (/LinkedIn/i.test(userAgent)) return true;
  if (/FBAN|FBAV/i.test(userAgent)) return true;
  if (/Twitter/i.test(userAgent)) return true;
  if (/Instagram/i.test(userAgent)) return true;
  // Enhanced TikTok detection
  if (/TikTok|ByteDance|Musically|TikTokWebView|TikTokBrowser/i.test(userAgent)) return true;
  if (/Pinterest/i.test(userAgent)) return true;
  if (/Snapchat/i.test(userAgent)) return true;
  
  // Generic in-app browser detection
  if (/wv|Line|KAKAOTALK|Instagram|FBAN|FBAV|Twitter|LinkedIn|TikTok|ByteDance|Musically|TikTokWebView|TikTokBrowser/i.test(userAgent)) return true;
  
  return false;
}

export function AuthPrompt() {
  const inAppBrowser = isInAppBrowser();
  const providers = inAppBrowser ? ['facebook', 'apple'] : ['google', 'facebook', 'apple'];

  return (
    <div className="w-full" data-auth-prompt>
      {inAppBrowser && (
        <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-lg">
          <div className="flex items-start">
            <svg className="w-4 h-4 text-orange-600 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
            <div>
              <p className="text-sm text-orange-700">
                Please open in your default browser to use Google Sign In.
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm">
        <Auth
          supabaseClient={supabase}
          appearance={{ 
            theme: ThemeSupa,
            style: {
              button: {
                borderRadius: '0.75rem',
                fontSize: '0.875rem',
                fontWeight: '600',
                padding: '0.75rem 1rem',
              },
              input: {
                borderRadius: '0.75rem',
                fontSize: '0.875rem',
                padding: '0.75rem',
              },
            },
          }}
          providers={providers}
          magicLink={true}
          view="magic_link"
          redirectTo={window.location.href}
        />
      </div>

      {/* Terms and Privacy Notice */}
      <div className="mt-4 pt-4 border-t border-gray-200">
        <p className="text-xs text-gray-500 text-center">
          By signing in, you agree to our{' '}
          <Link to="/terms-of-service" className="text-indigo-600 hover:text-indigo-800 underline">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link to="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 underline">
            Privacy Policy
          </Link>.
        </p>
      </div>

      <div className="text-center mt-4">
        <p className="text-xs text-gray-500">
          Powered by{' '}
          <a 
            href="https://www.zapt.ai" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 cursor-pointer"
          >
            ZAPT
          </a>
        </p>
      </div>
    </div>
  );
}